module.exports = __webpack_public_path__ + "img/icon-campain.f3492743.svg";